export default function LinkTag(props) {
    return (
        <div className={'LinkTag ' + props.class}>
            <a className="link-name" href={props.page} target="blank">
                {props.name}
            </a>
        </div>
    );
}
